import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

export default function NewsItem(props) {
    return (<Card className={props.className} raised>
        <CardContent className=''>
            <h1>{props.header}</h1>
            <h3>{props.date}</h3>
            <div className='body2'>{props.body}</div>
        </CardContent>
    </Card>);
};